import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { motion } from "framer-motion";
import heroBg from "../../static/media/Home/Hero.webp";
import heroMobileBg from "../../static/media/Home/Hero2.webp";

const PRIMARY = "#06BBC7";
const DARK_PRIMARY = "#047b84";
const YELLOW = "#F7C948";
 
const MotionTypography = motion(Typography);
const MotionButton = motion(Button);

const HeroSection = () => {
  const whatsappMessage = encodeURIComponent(
    "Hola Lily's Sunflower, quiero reservar una cita."
  );

  const whatsappUrl = `https://wa.me/593984781610?text=${whatsappMessage}`;

  return (
    <Box
      component="section"
      sx={{
        minHeight: { xs: "560px", sm: "600px", md: "560px"},
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        backgroundImage: {
          xs: `url(${heroMobileBg})`,
          md: `url(${heroBg})`,
        },
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: {
          xs: "center bottom",
          sm: "center bottom",
          md: "center center",
        },
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background: {
            xs: "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(255,255,255,0.88) 47%, rgba(255,255,255,0.18) 100%)",
            md: "linear-gradient(90deg, rgba(255,255,255,0.96) 0%, rgba(255,255,255,0.8) 43%, rgba(255,255,255,0.12) 78%)",
          },
          zIndex: 1,
        },
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 2,
          pl: { xs: 3, sm: 5, md: 20 },
          pr: { xs: 3, sm: 5, md: 4 },
        }}
      >
        <Box
          sx={{
            maxWidth: { xs: 390, sm: 520, md: 650, lg: 710 },
            pt: { xs: 4, md: 0 },
            pb: { xs: 14, sm: 16, md: 0 },
          }}
        >
          <Typography
            sx={{
              color: DARK_PRIMARY,
              fontSize: { xs: "0.78rem", md: "0.88rem" },
              fontWeight: 700,
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              mb: 1.2,
            }}
          >
            CENTRO ESTÉTICO INTEGRAL
          </Typography>

          <Typography
            component="h1"
            sx={{
              fontFamily: "'Playfair Display', serif",
              color: DARK_PRIMARY,
              fontSize: {
                xs: "2.45rem",
                sm: "3.2rem",
                md: "4.35rem",
                lg: "4.95rem",
              },
              fontWeight: 600,
              lineHeight: 0.98,
              letterSpacing: "-0.045em",
              mb: { xs: 1.8, md: 2.3 },
            }}
          >
            Cuidado facial y corporal con resultados visibles
          </Typography>

          <MotionTypography
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, ease: "easeOut", delay: 0.12 }}
            viewport={{ once: true, amount: 0.35 }}
            sx={{
              color: "#1f2937",
              fontSize: { xs: "1.02rem", sm: "1.14rem", md: "1.28rem" },
              fontWeight: 500,
              lineHeight: 1.55,
              maxWidth: { xs: 370, sm: 500, md: 620 },
              mb: { xs: 1.8, md: 2 },
            }}
          >
            Tratamientos personalizados para tu piel, tu cuerpo y tu momento de
            bienestar.
          </MotionTypography>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{
              alignItems: { xs: "stretch", sm: "center" },
              maxWidth: { xs: 300, sm: "none" },
            }}
          >
            <MotionButton
              component="a"
              href="/agendar-cita"
              variant="contained"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -4, scale: 1.03 }}
              whileTap={{ scale: 0.96 }}
              transition={{ duration: 0.24, ease: "easeOut", delay: 0.18 }}
              viewport={{ once: true, amount: 0.35 }}
              sx={{
                bgcolor: YELLOW,
                color: "#1f2937",
                px: 4,
                py: 1.18,
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: 700,
                fontSize: "0.95rem",
                boxShadow: "none",
                "&:hover": {
                  bgcolor: "#efbd35",
                  boxShadow: "0 14px 28px rgba(247, 201, 72, 0.28)",
                },
              }}
            >
              Agendar Cita
            </MotionButton>

            <MotionButton
              component="a"
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -4, scale: 1.03 }}
              whileTap={{ scale: 0.96 }}
              transition={{ duration: 0.24, ease: "easeOut", delay: 0.24 }}
              viewport={{ once: true, amount: 0.35 }}
              sx={{
                color: DARK_PRIMARY,
                borderColor: "rgba(6, 187, 199, 0.58)",
                bgcolor: "rgba(255,255,255,0.84)",
                px: 4,
                py: 1.18,
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: 700,
                fontSize: "0.95rem",
                boxShadow: "none",
                "&:hover": {
                  borderColor: PRIMARY,
                  bgcolor: "rgba(6, 187, 199, 0.08)",
                  boxShadow: "0 14px 28px rgba(6, 187, 199, 0.18)",
                },
              }}
            >
              Reservar por WhatsApp
            </MotionButton>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;